import { DatabaseSnapshot } from 'angularfire2/database/interfaces';
import * as moment from 'moment';

export class Event {
  static readonly PropertyKey = {
    companyId: 'company_id',
    name: 'name',
    address: 'address',
    description: 'description',
    startTimestamp: 'start_timestamp',
    facebookId: 'facebook_id',
    twitterScreenName: 'twitter_screen_name',
    instagramUsername: 'instagram_username',
    linkedinId: 'linkedin_id',
    bannerUrl: 'banner_url',
    activitiesMapUrl: 'activities_map_url',
    endTimestamp: 'end_timestamp',
    latitude: 'latitude',
    longitude: 'longitude',
    isPartyFeatureEnabled: 'is_party_feature_enabled',
    appPrimaryColor: 'app_primary_color',
    appAccentColor: 'app_accent_color',
    tagLine: 'tag_line',
    hashTag: 'hashtag',
    appStoreUrl: 'app_store_url',
    playStoreUrl: 'play_store_url',
    apkDownloadUrl: 'apk_download_url',
    isShowFeedbackForm: 'is_show_feedback_form'
  };

  // Set on demand
  public activityAreaImageURL$?: Promise<URL | null>;
  public logoImageURL$?: Promise<URL | null>;
  public bannerImageURL$?: Promise<URL | null>;
  public bannerBackgroundImageURL$?: Promise<URL | null>;

  constructor(
    public id: string,
    public companyId: string | null,
    public name: string | null,
    public address: string | null,
    public description: string | null,
    public startTimestamp: moment.Moment | null,
    public endTimestamp: moment.Moment | null,
    public bannerUrl: string | null,
    public activitiesMapUrl: string | null,
    public facebookId: string | null,
    public twitterScreenName: string | null,
    public instagramUsername: string | null,
    public linkedinId: string | null,
    public latitude: number | null,
    public longitude: number | null,
    public isPartyFeatureEnabled: boolean | null,
    public appPrimaryColor: string | null,
    public appAccentColor: string | null,
    public tagLine: string | null,
    public hashTag: string | null,
    public appStoreUrl: string | null,
    public playStoreUrl: string | null,
    public apkDownloadUrl: string | null) { }

  static fromDatabaseSnapshot(snapshot: DatabaseSnapshot): Event | null {
    const id = snapshot.key;

    if (!snapshot.exists() || !id) {
      return null;
    }

    const companyId = snapshot.child(this.PropertyKey.companyId).val();
    const name = snapshot.child(this.PropertyKey.name).val();
    const address = snapshot.child(this.PropertyKey.address).val();
    const description = snapshot.child(this.PropertyKey.description).val();
    const facebookId = snapshot.child(this.PropertyKey.facebookId).val();
    const twitterScreenName = snapshot.child(this.PropertyKey.twitterScreenName).val();
    const instagramUsername = snapshot.child(this.PropertyKey.instagramUsername).val();
    const linkedinId = snapshot.child(this.PropertyKey.linkedinId).val();
    const bannerUrl = snapshot.child(this.PropertyKey.bannerUrl).val();
    const activitiesMapUrl = snapshot.child(this.PropertyKey.activitiesMapUrl).val();
    const latitude = snapshot.child(this.PropertyKey.latitude).val();
    const longitude = snapshot.child(this.PropertyKey.longitude).val();
    const isPartyFeatureEnabled = snapshot.child(this.PropertyKey.isPartyFeatureEnabled).val();

    let startTimestamp: moment.Moment | null = null;
    const startTimestampVal = snapshot.child(this.PropertyKey.startTimestamp).val();
    if (startTimestampVal) {
      startTimestamp = moment(Number(startTimestampVal));
    }

    let endTimestamp: moment.Moment | null = null;
    const endTimestampVal = snapshot.child(this.PropertyKey.endTimestamp).val();
    if (endTimestampVal) {
      endTimestamp = moment(Number(endTimestampVal));
    }

    const appPrimaryColor = snapshot.child(this.PropertyKey.appPrimaryColor).val();
    const appAccentColor = snapshot.child(this.PropertyKey.appAccentColor).val();

    const tagLine = snapshot.child(this.PropertyKey.tagLine).val();
    const hashTag = snapshot.child(this.PropertyKey.hashTag).val();

    const appStoreUrl = snapshot.child(this.PropertyKey.appStoreUrl).val();
    const playStoreUrl = snapshot.child(this.PropertyKey.playStoreUrl).val();
    const apkDownloadUrl = snapshot.child(this.PropertyKey.apkDownloadUrl).val();

    return new this(id, companyId, name, address, description, startTimestamp, endTimestamp, bannerUrl, activitiesMapUrl,
      facebookId, twitterScreenName, instagramUsername, linkedinId, latitude, longitude, isPartyFeatureEnabled,
      appPrimaryColor, appAccentColor, tagLine, hashTag, appStoreUrl, playStoreUrl, apkDownloadUrl);
  }
}



// WEBPACK FOOTER //
// D:/ThinkBIT/work-projects/confe/hosting/src/app/models/event.ts